import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { environment } from '../environments/environment';
import { OAuthService } from 'angular-oauth2-oidc';
import { authCodeFlowConfig } from './auth-config';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit {

  showDevLinks: boolean;

  constructor(
    private readonly oauthService: OAuthService,
  ) {
    this.showDevLinks = !environment.production;
    'nginject'
  }

  ngOnInit() {
    // Configuration only. The discovery document is loaded on demand by the redirect guard and
    // by AuthorizationService, so there is no bootstrap race over who loaded it first.
    this.oauthService.configure(authCodeFlowConfig);
  }

  title = 'Landing Page';
}
